<template src="./documents.html"></template>
<script>
import Axios from "axios";
import $ from "jquery";
var moment = require("moment");

import DriverNames from "@/assets/js/driver_names.js";
export default {
  components: {},
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
    getDriverNames: function (data) {
      return DriverNames(data);
    },
  },
  data() {
    return {
      basic: {
        currentPage: 1,
        totalPages: 0,
      },
      CategoryName: "",
      VehicleImageEndpoint: Endpoints.Vehicle.Image + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      ShowLoader: false,
      DocumentList: [],
      NewDocument: {},
      MileageUnit: "Mileage",
      ShowAddDocument: false,
      PopupLoader: false,
      infoOpened: false,
      DocumentModelCategories: [],
      DocumentCategories: [],
      DocumentModelSubCategories: [],
      DocumentModelFields: {},
      file: "",
      front_file: "",
      back_file: "",
      license_front_image: "",
      license_back_image: "",
      locationPoints: "",
      ShowAddCategoryModel: false,
      NewCategory: {},
      Vehicles: [],
      Assets: [],
      Drivers: [],
      AssginDocument: { driver_id: 0, document_id: 0 },
      ViewDocument: {},
      ShowViewDetailModel: false,
      ShowSendDriverModel: false,
      DocumentTypes: [],
      StorageType: "",
      CurrentPage: [],
      SelectAllDriver: false,
      SelectAllAsset: false,
      SelectDriver: false,
      ShowMap: false,
      ShowFileInput: false,
      DriverSearchKey: "",
      SearchKey: "",
      driver: {
        ids: [],
      },
      center: {
        lat: 55.232753,
        lng: -3.944403,
      },
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
        content: "",
      },
      SelectAllVehicle: false,
      AccountPermissions: [],
      FleetSubscription: [],
      ShowDocuments: false,
      ShowDocumentAdd: false,
      ShowDocumentEdit: false,
      ShowDocumentDelete: false,
      ShowDocumentDownload: false,
      ShowDocumentAddCategory: false,
      ShowDocumentDeleteCategory: false,
      ShowDocumentSendToDriver: false,
      Subcategories: [],
    };
  },
  mounted() {
    document.title = pbx_SiteTitle + " - Documents";
    this.GetCategoriesList();
    this.AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
    );
    var AccountPermissions = this.AccountPermissions;
    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );
    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if (
      FleetSubscriptionModules["Hierarchy System"] &&
      (!AccountPermissions.Documents || !AccountPermissions.Documents.enable)
    ) {
      this.$router.push("/");
    }

    if (
      this.AccountPermissions &&
      this.AccountPermissions.Documents &&
      this.AccountPermissions.Documents.enable
    ) {
      this.ShowDocuments = true;
      if (this.AccountPermissions.Documents.add) {
        this.ShowDocumentAdd = true;
      }
      if (this.AccountPermissions.Documents.edit) {
        this.ShowDocumentEdit = true;
      }
      if (this.AccountPermissions.Documents.delete) {
        this.ShowDocumentDelete = true;
      }
      if (this.AccountPermissions.Documents.download) {
        this.ShowDocumentDownload = true;
      }
      if (this.AccountPermissions.Documents.delete_category) {
        this.ShowDocumentDeleteCategory = true;
      }
      if (this.AccountPermissions.Documents.add_category) {
        this.ShowDocumentAddCategory = true;
      }
      if (this.AccountPermissions.Documents.send_to_driver) {
        this.ShowDocumentSendToDriver = true;
      }
    }
    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowDocuments = true;
      this.ShowDocumentAdd = true;
      this.ShowDocumentEdit = true;
      this.ShowDocumentDelete = true;
      this.ShowDocumentDownload = true;
      this.ShowDocumentDeleteCategory = true;
      this.ShowDocumentAddCategory = true;
      this.ShowDocumentSendToDriver = true;
    }
    var CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (CompanyData.mileage_unit == 2) {
      this.MileageUnit = "KM";
    }
  },
  methods: {
    showInput(event) {
      if (event.target.checked) {
        this.ShowFileInput = true;
      } else {
        this.ShowFileInput = false;
      }
    },
    setCategory(categoryName) {
      $(".file-sidebar").on("click", "div.leftnav", function (event) {
        $("div.leftnav").removeClass("btn-primary").addClass("btn-light");
        $(this).removeClass("btn-light").addClass("btn-primary");
      });
      this.DocumentTypes = [];
      this.DocumentList = [];
      this.CategoryName = categoryName;
      this.Subcategories = [];
      this.GetDocumentList();
    },
    getId(index) {
      var index = index.replaceAll(" ", "");
      return index
        .replace(/(?!\w|\s)./g, "")
        .replace(/\s+/g, " ")
        .replace(/^(\s*)([\W\w]*)(\b\s*$)/g, "$2");
    },
    SearchDocument() {
      this.GetDocumentList("search");
    },
    ClearSearch() {
      this.SearchKey = "";
      this.GetDocumentList("search");
    },
    GetDocumentList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      obj.category = this.CategoryName;
      obj.type = "DocumentList";
      if (type == "search") {
        if (this.SearchKey != "") {
          obj.search_key = this.SearchKey;
        }
      }
      this.ShowLoader = true;
      this.DocumentTypes = [];
      let docObj = {};
      docObj[this.CategoryName] = {};
      Axios.post(Endpoints.Dcoument.SubCategories, obj).then((Response) => {
        if (Response.data.success) {
          this.Subcategories = Response.data.subcategories;
          if (this.Subcategories.length > 0) {
            this.Subcategories.forEach((element) => {
              docObj[this.CategoryName][element.sub_category] = {};
              var obj2 = {
                token: localStorage.getItem("token"),
                page: 1,
                category: this.CategoryName,
                sub_category: element.sub_category,
              };
              if (this.SearchKey != "") {
                obj2.search_key = this.SearchKey;
              }
              Axios.post(Endpoints.Dcoument.DocumentPagination, obj2).then(
                (Response2) => {
                  this.ShowLoader = false;
                  if (Response2.data.success) {
                    docObj[this.CategoryName][element.sub_category] = {
                      documents: Response2.data.documents,
                      page: 1,
                      last_page: Response2.data.documents.last_page,
                    };
                  }
                }
              );
              setTimeout(() => {
                this.DocumentTypes = docObj;
              }, 300);
            });
          } else {
            this.ShowLoader = false;
          }

          /*if (typeof Response.data.documents != "undefined") {
              this.DocumentTypes = [];
              this.DocumentTypes[this.CategoryName] = [];
              this.DocumentList.subcategories.forEach((element2) => {
                this.DocumentTypes[this.CategoryName][element2.sub_category] = {
                  documents: element2.documents,
                  page: 1,
                  last_page: element2.documents.last_page,
                };
              });
            }*/
        }
      });
    },
    ViewAll(currentPage, category, sub_category) {
      $("#view-more-" + category + "-" + sub_category).html("Processing...");
      var nextPage = currentPage + 1;
      var obj = {
        token: localStorage.getItem("token"),
        page: nextPage,
        category: category,
        sub_category: sub_category,
      };
      if (this.SearchKey != "") {
        obj.search_key = this.SearchKey;
      }
      Axios.post(Endpoints.Dcoument.DocumentPagination, obj).then(
        (Response) => {
          $("#view-more-" + category + "-" + sub_category).html("View More");
          if (Response.data.success) {
            this.DocumentTypes[category][sub_category].page = nextPage;
            this.DocumentTypes[category][sub_category].last_page =
              Response.data.documents.last_page;
            Response.data.documents.data.forEach((element) => {
              this.DocumentTypes[category][sub_category].documents.data.push(
                element
              );
            });
          }
        }
      );
    },
    GetDriversList(type = "") {
      var obj = { token: localStorage.getItem("token") };
      if (type == "search") {
        obj.searchkey = this.DriverSearchKey;
        this.ResetDriverArray();
      }
      Axios.post(Endpoints.Driver.List, obj).then((Response) => {
        if (Response.data.success) {
          this.Drivers = Response.data.drivers;
        }
      });
    },
    check(e) {
      if (e.target.checked) {
        this.SelectAllDriver = true;
        this.SelectDriver = true;
        this.driver.ids = [];
        this.Drivers.forEach((element) => {
          this.driver.ids.push(element.id);
        });
      } else {
        this.ResetDriverArray();
      }
    },
    select: function () {
      this.SelectAllDriver = false;
    },
    ResetDriverArray() {
      this.SelectAllDriver = false;
      this.SelectDriver = false;
      this.driver.ids = [];
      return true;
    },
    checkVehicle(e) {
      if (e.target.checked) {
        this.SelectAllVehicle = true;
        //this.SelectDriver = true;
        this.NewDocument.fields["vehicle"]["value"] = [];
        this.Vehicles.forEach((element) => {
          this.NewDocument.fields["vehicle"]["value"].push(element.id);
        });
      } else {
        this.ResetVehicleArray();
      }
    },
    checkAssets(e) {
      if (e.target.checked) {
        this.SelectAllAsset = true;
        this.NewDocument.fields["asset"]["value"] = [];
        this.Assets.forEach((element) => {
          this.NewDocument.fields["asset"]["value"].push(element.id);
        });
      } else {
        this.ResetAssetArray();
      }
    },
    selectVehicle: function () {
      this.SelectAllVehicle = false;
    },
    selectAsset: function () {
      this.SelectAllAsset = false;
    },
    ResetVehicleArray() {
      this.SelectAllVehicle = false;
      //this.SelectDriver = false;
      this.NewDocument.fields["vehicle"]["value"] = [];
      return true;
    },
    ResetAssetArray() {
      this.SelectAllVehicle = false;
      this.NewDocument.fields["asset"]["value"] = [];
      return true;
    },
    GetVehiclesListForAssign() {
      if (sessionStorage.getItem("DocumentVehicles")) {
        this.Vehicles = JSON.parse(sessionStorage.getItem("DocumentVehicles"));
      } else {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Dcoument.VehicleList, obj).then((Response) => {
          if (Response.data.success) {
            this.Vehicles = Response.data.vehicles;
            sessionStorage.setItem(
              "DocumentVehicles",
              JSON.stringify(this.Vehicles)
            );
          }
        });
      }
    },
    GetAssetsListForAssign() {
      if (sessionStorage.getItem("DocumentAssets")) {
        this.Assets = JSON.parse(sessionStorage.getItem("DocumentAssets"));
      } else {
        var obj = { token: localStorage.getItem("token") };
        Axios.post(Endpoints.Assets.List, obj).then((Response) => {
          if (Response.data.success) {
            this.Assets = Response.data.AssetsList;
            sessionStorage.setItem(
              "DocumentAssets",
              JSON.stringify(this.Assets)
            );
          }
        });
      }
    },
    DeleteDocument(document_id) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#514b71",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Deleting...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Dcoument.Delete, {
            token: localStorage.getItem("token"),
            document_id: document_id,
          }).then((Response) => {
            if (Response.data.success == true) {
              this.$swal.close();
              this.GetDocumentList();
              this.$swal("Document Deleted Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal("Error:" + Response.data.message, "", "error").then(
                () => {}
              );
            }
          });
        }
      });
    },
    GetCategoriesList() {
      Axios.post(Endpoints.Dcoument.Categories, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          this.DocumentCategories = Response.data.categories;
          sessionStorage.setItem(
            "DocumentCategories",
            JSON.stringify(this.DocumentCategories)
          );
          setTimeout(() => {
            this.LoadDocuments();
          }, 500);
        }
      });
    },
    LoadDocuments() {
      if (this.DocumentCategories.length > 0) {
        this.DocumentCategories.forEach((element, index) => {
          if (index == 0) {
            this.CategoryName = element.category_name;
            this.GetDocumentList();
          }
        });
      }
    },
    DocumentModelLoadCategories() {
      this.PopupLoader = true;
      this.DocumentModelCategories = [];
      Axios.post(Endpoints.Dcoument.Categories, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          if (Response.data.categories.length > 0) {
            Response.data.categories.forEach((element) => {
              this.DocumentModelCategories.push({
                id: element,
                title: element,
              });
            });
            this.DocumentModelCategories.push({ id: -1, title: "Add New" });
          } else {
            this.DocumentModelCategories.push({ id: -1, title: "Add New" });
          }
        }
      });
    },
    AddDocumentOpen(category = "") {
      this.driver.ids = [];
      this.NewDocument = {};
      this.ShowAddDocument = true;
      this.NewDocument.vehicle_id = 0;
      this.NewDocument.asset_id = 0;
      this.NewDocument.export_type = 1;
      this.NewDocument.scope = 1;
      this.NewDocument.type = 0;
      this.NewDocument.title = "";
      this.NewDocument.category = category;
      this.NewDocument.sub_category = 0;
      this.NewDocument.new_sub_category_name = "";
      this.NewDocument.fields = {};
      this.NewDocument.files = "";
      this.NewDocument.filename = "";
      this.DocumentModelSubCategories = [];
      this.DocumentModelFields = {};
      this.DocumentModelLoadSubCategories(category);
      this.GetDriversList();
      this.GetVehiclesListForAssign();
      this.GetAssetsListForAssign();
    },
    EditDocument(document) {
      this.NewDocument = {};
      this.ShowAddDocument = true;
      $("#file").val(null);
      this.file = "";
      this.NewDocument.id = document.id;
      this.NewDocument.document_id = document.id;
      this.NewDocument.title = document.title;
      this.NewDocument.category = document.category;
      this.NewDocument.sub_category = document.sub_category;
      this.NewDocument.editdocument = true;
      if (typeof document.fields === "object") {
        this.NewDocument.fields = document.fields;
        this.DocumentModelFields = document.fields;
      } else {
        this.NewDocument.fields = JSON.parse(document.fields);
        this.DocumentModelFields = JSON.parse(document.fields);
      }
      this.NewDocument.type = document.sub_category;
      for (const index in this.NewDocument.fields) {
        if (index == "mileage") {
          this.NewDocument.fields["mileage"]["required"] = true;
        }
      }
      this.GetDriversList();
      this.GetVehiclesListForAssign();
      this.GetAssetsListForAssign();
    },
    DocumentModelLoadSubCategories() {
      this.PopupLoader = true;
      this.NewDocument.sub_category = 0;
      this.DocumentModelSubCategories = [];
      Axios.post(Endpoints.Dcoument.SubCategories, {
        token: localStorage.getItem("token"),
        category: this.NewDocument.category,
      }).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.subcategories.length > 0) {
          Response.data.subcategories.forEach((element) => {
            this.DocumentModelSubCategories.push({
              id: element,
              title: element.replace("_", " "),
            });
          });
          if (this.NewDocument.category != "fuel") {
            this.DocumentModelSubCategories.push({
              id: -1,
              title: "Add New",
            });
          }
        } else {
          this.DocumentModelSubCategories.push({ id: -1, title: "Add New" });
        }
      });
    },
    onSelectSubCategory() {
      if (this.NewDocument.sub_category == "-1") {
        this.NewDocument.title = "";
        this.NewDocument.fields = {};
        this.NewDocument.new_sub_category_name = "";
        var obj = {
          description: {
            title: "Description",
            type: "text",
            sort_order: 1,
            required: true,
          },
          expiry: {
            title: "Expiry",
            type: "date",
            sort_order: 2,
          },
        };
        if (this.NewDocument.category == "vehicle") {
          var obj2 = {
            vehicle: {
              title: "Vehicle",
              type: "text",
              sort_order: 3,
              value: [],
              required: true,
            },
          };
          obj = Object.assign(obj, obj2);
        }
        if (this.NewDocument.category == "asset") {
          var obj2 = {
            asset: {
              title: "Assets",
              type: "text",
              sort_order: 3,
              value: [],
              required: true,
            },
          };
          obj = Object.assign(obj, obj2);
        }
        this.NewDocument.fields = obj;
        this.DocumentModelFields = obj;
      }
      if (this.NewDocument.sub_category != 0) {
        this.PopupLoader = true;
        Axios.post(Endpoints.Dcoument.Model, {
          token: localStorage.getItem("token"),
          category: this.NewDocument.category,
          sub_category: this.NewDocument.sub_category,
        }).then((Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true && Response.data.models[0]) {
            var model = Response.data.models[0];
            this.NewDocument.title = model.title;
            this.NewDocument.fields = JSON.parse(model.fields);
            this.DocumentModelFields = JSON.parse(model.fields);
            for (const index in this.DocumentModelFields) {
              if (index == "vehicle") {
                this.NewDocument.fields["vehicle"]["value"] = [];
                this.DocumentModelFields["vehicle"]["value"] = [];
              }
              if (index == "asset") {
                this.NewDocument.fields["asset"]["value"] = [];
                this.DocumentModelFields["asset"]["value"] = [];
              }
              if (index == "mileage") {
                this.NewDocument.fields["mileage"]["required"] = true;
                this.DocumentModelFields["mileage"]["required"] = true;
              }
            }
          }
        });
      }
    },
    onSelectVehicle(vrm) {
      if (vrm != "") {
        this.Vehicles.forEach((element) => {
          if (element.vrm == vrm) {
            this.NewDocument.vehicle_id = element.id;
          }
        });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.StorageType = "CFD";
      if (this.NewDocument.category == "fuel") {
        this.StorageType = "CFR";
      }
    },
    handleFrontFileUpload() {
      this.front_file = this.$refs.front_file.files[0];
      this.StorageType = "CFD";
    },
    handleBackFileUpload() {
      this.back_file = this.$refs.back_file.files[0];
      this.StorageType = "CFD";
    },
    UploadFrontFile() {
      if (this.front_file != "" && this.back_file != "") {
        $("#upload_img_btn").html("Processing...");
        this.PopupLoader = true;
        let formData = new FormData();
        formData.append("token", localStorage.getItem("token"));
        formData.append("storage_type", this.StorageType);
        formData.append("file", this.front_file);
        Axios.post(Endpoints.File.Upload, formData).then((Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true) {
            this.license_front_image = Response.data.file;
            this.UploadBackFile();
          } else {
            this.$swal("Error in File Uploading", "", "error").then(() => {});
          }
        });
      } else {
        this.$swal(
          "Please choose license front and back image",
          "",
          "error"
        ).then(() => {});
      }
    },
    UploadBackFile() {
      this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("storage_type", this.StorageType);
      formData.append("file", this.back_file);
      Axios.post(Endpoints.File.Upload, formData).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          this.license_back_image = Response.data.file;
          this.GenerateLicensePdf();
        } else {
          this.$swal("Error in File Uploading", "", "error").then(() => {});
        }
      });
    },
    GenerateLicensePdf() {
      this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("front_image", this.license_front_image);
      formData.append("back_image", this.license_back_image);
      Axios.post(Endpoints.Dcoument.GenerateLicensePdf, formData).then(
        (Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true) {
            this.NewDocument.files = Response.data.file;
            this.NewDocument.filename = Response.data.file;
            $("#upload_img_btn").html("Upload Front / Back Image");
            this.$swal("File Uploaded Successfully", "", "success").then(
              () => {}
            );
          } else {
            this.$swal("Error in File Uploading", "", "error").then(() => {});
          }
        }
      );
    },
    UploadFile() {
      this.PopupLoader = true;
      let formData = new FormData();
      formData.append("token", localStorage.getItem("token"));
      formData.append("storage_type", this.StorageType);
      formData.append("file", this.file);
      Axios.post(Endpoints.File.Upload, formData).then((Response) => {
        this.PopupLoader = false;
        if (Response.data.success == true) {
          this.NewDocument.files = Response.data.file;
          this.NewDocument.filename = this.file.name;
          this.$swal("File Uploaded Successfully", "", "success").then(
            () => {}
          );
        } else {
          this.$swal("Error in File Uploading", "", "error").then(() => {});
        }
      });
    },
    AddDocumentSubmit() {
      var error = false;
      var errorStr = "";
      /*if(this.NewDocument.files==""){
  		error=true
  		errorStr +="<li>Please Upload File, File is Required</li>"
  		}*/
      if (this.NewDocument.sub_category == "") {
        error = true;
        errorStr += "<li>Please Select Document Type</li>";
      }
      if (
        this.NewDocument.sub_category == "-1" &&
        this.NewDocument.new_sub_category_name == ""
      ) {
        error = true;
        errorStr += "<li>Please Enter Document Type</li>";
      }
      if (this.NewDocument.fields) {
        for (const [key, ele] of Object.entries(this.NewDocument.fields)) {
          if (key != "latitude" && key != "longitude" && ele.title != "Total Cost (Inc Vat)") {
            if (ele.required && (!ele.value || ele.value == "")) {
              error = true;
              errorStr += "<li>Please Enter " + ele.title + "</li>";
            }
            if (key == "mileage" && ele.value <= 0) {
              error = true;
              errorStr += "<li>Mileage should be greator then 0</li>";
            }
          }
        }
      }
      if (error == true) {
        this.$swal("Following Error Found!", errorStr, "error").then(() => {});
      } else {
        if (this.NewDocument.sub_category == "-1") {
          this.NewDocument.title =
            this.NewDocument.category +
            " " +
            this.NewDocument.new_sub_category_name;
          this.NewDocument.sub_category =
            this.NewDocument.new_sub_category_name;
          this.NewDocument.add_new_sub_category = 1;
        }
        this.$swal({
          title: "Adding Document...",
          text: "Please wait...",
          imageUrl: require("@/assets/images/LoadingTwo.gif"),
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        this.PopupLoader = true;
        this.NewDocument.token = localStorage.getItem("token");
        (this.NewDocument.driver_ids = this.driver.ids),
          Axios.post(Endpoints.Dcoument.Create, this.NewDocument).then(
            (Response) => {
              this.PopupLoader = false;
              if (Response.data.success == true) {
                this.ShowAddDocument = false;
                this.GetDocumentList();
                this.$swal("Document Added Successfully", "", "success").then(
                  () => {}
                );
              } else {
                this.$swal(Response.data.message, "", "error").then(() => {});
              }
            }
          );
      }
    },
    AddDocumentCategory() {
      this.ShowAddCategoryModel = true;
      this.NewCategory = {};
      this.NewCategory.category_name = "";
      this.NewCategory.sub_category_name = "";
    },
    AddCategorySubmit() {
      var error = false;
      var errorStr = "";
      if (this.NewCategory.category_name == "") {
        error = true;
        errorStr += "<li>Please Enter Category Name</li>";
      }
      if (this.NewCategory.sub_category_name == "") {
        error = true;
        errorStr += "<li>Please Enter Document Type</li>";
      }
      if (error == true) {
        this.$swal("Following Error Found!", errorStr, "error").then(() => {});
      } else {
        var obj = {
          description: {
            title: "Description",
            type: "text",
            sort_order: 1,
            required: true,
          },
          expiry: {
            title: "Expiry",
            type: "date",
            sort_order: 2,
          },
        };
        this.NewCategory.fields = obj;
        this.$swal({
          title: "Adding Category...",
          text: "Please wait...",
          imageUrl: require("@/assets/images/LoadingTwo.gif"),
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        this.NewCategory.token = localStorage.getItem("token");
        Axios.post(Endpoints.Dcoument.CategoryCreate, this.NewCategory).then(
          (Response) => {
            if (Response.data.success == true) {
              this.ShowAddCategoryModel = false;

              //get categories
              sessionStorage.removeItem("DocumentCategories");
              this.GetCategoriesList();
              this.$swal("Category Added Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal(Response.data.message, "", "error").then(() => {});
            }
          }
        );
      }
    },
    AssignDriver(document) {
      this.driver.ids = [];
      this.AssginDocument.document_id = document.id;
      this.AssginDocument.driver_id = 0;
      this.ShowSendDriverModel = true;
      this.GetDriversList();
    },
    SubmitSendToDriver() {
      if (this.AssginDocument.document_id > 0 && this.driver.ids.length > 0) {
        this.$swal({
          title: "Sending...",
          text: "Please wait...",
          imageUrl: require("@/assets/images/LoadingTwo.gif"),
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        Axios.post(Endpoints.Dcoument.SendDocument, {
          token: localStorage.getItem("token"),
          driver_id: this.driver.ids,
          document_id: this.AssginDocument.document_id,
        }).then((Response) => {
          if (Response.data.success == true) {
            this.ResetDriverArray();
            //this.GetVehiclesList();
            $("#SendDriverModel .close").trigger("click");
            this.$swal(
              "Document Sent to Driver Successfully",
              "",
              "success"
            ).then(() => {});
          } else {
            this.$swal("Error:" + Response.data.message, "", "error").then(
              () => {}
            );
          }
        });
      } else {
        this.$swal({
          icon: "error",
          title: "Please Select Driver",
        });
      }
    },
    ViewDetailDocument(document) {
      this.ShowMap = false;
      this.ViewDocument = document;
      if (
        this.ViewDocument.fields.latitude &&
        this.ViewDocument.fields.latitude.value &&
        this.ViewDocument.fields.latitude.value != "" &&
        this.ViewDocument.fields.longitude &&
        this.ViewDocument.fields.longitude.value &&
        this.ViewDocument.fields.longitude.value != ""
      ) {
        this.ShowMap = true;
        const marker = {
          lat: parseFloat(this.ViewDocument.fields.latitude.value),
          lng: parseFloat(this.ViewDocument.fields.longitude.value),
        };
        this.locationPoints = marker;
        this.infoOptions.content =
          '<div id="mapcontent"><h1 id="firstHeading" class="firstHeading" style="margin: 0px;">' +
          this.ViewDocument.fields.vehicle.value +
          "</h1></div>";
      }

      this.ShowViewDetailModel = true;
    },
    DownloadDocument(document) {
      window.open(this.ImageEndpoint + document.files, "_blank");
    },
    SearchDriver() {
      this.GetDriversList("search");
    },
    DeleteCategory(category_name) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#514b71",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Deleting...",
            text: "Please wait...",
            imageUrl: require("@/assets/images/LoadingTwo.gif"),
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Dcoument.CategoryDelete, {
            token: localStorage.getItem("token"),
            category: category_name,
          }).then((Response) => {
            if (Response.data.success == true) {
              this.$swal.close();
              //get categories
              sessionStorage.removeItem("DocumentCategories");
              this.GetCategoriesList();
              this.$swal("Category Deleted Successfully", "", "success").then(
                () => {}
              );
            } else {
              this.$swal("Error:" + Response.data.message, "", "error").then(
                () => {}
              );
            }
          });
        }
      });
    },
  },
};
</script>
<style type="text/css">
.form-padding {
  padding-left: 30px;
  padding-right: 30px;
}
.asset-name small {
  font-weight: normal;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 150px;
  font-size: 12px;
  vertical-align: middle;
}
.documentlist th,
.documentlist td {
  padding: 5px;
}
.DocumentSearchBox {
  width: 75%;
  position: relative;
}
.displayNone {
  display: none !important;
}
.margin-right {
  margin-right: 10px;
}
.viewdetail {
  cursor: pointer;
}
.DocumentListDiv.show {
  display: block;
}
.DocumentListDiv.hide {
  display: none;
}
.DocumentSearchBtn {
  width: 25%;
  text-align: right;
}
.DocumentListDiv .dropdown-basic .dropdown-toggle {
  font-size: 18px;
  font-weight: bold;
  transform: rotate(90deg);
  color: #000 !important;
  padding: 0px !important;
}
.display-flex {
  display: flex;
}
.position-relative {
  position: relative;
}
.DocumentListDiv .dropdown-basic .dropdown {
  position: absolute;
  right: 5px;
}
.DocumentListDiv .dropdown-basic .dropdown-toggle::after {
  display: none;
}
.DocumentListDiv ul.dropdown-menu {
  margin-top: 10px;
  margin-left: -110px;
  min-width: 140px !important;
}
.DocumentListDiv ul.dropdown-menu li a {
  text-align: right !important;
}
.driver_list_box {
  text-align: left;
  border: 1px solid #ced4da;
  padding: 11px;
  border-radius: 4px;
  overflow-y: scroll;
  height: 200px;
}
.position-relative {
  position: relative;
}
.driver-search-icon {
  position: absolute;
  right: 7px;
  top: 7px;
}
.driver_list_top_border {
  border-top: 1px solid #ccc;
  padding-top: 10px;
}
.view_more_div {
  width: 100%;
  text-align: center;
  margin-top: 20px;
}
.padding-left {
  padding-left: 35px !important;
}
.price-sign {
  position: absolute;
  top: 26px;
  background: #e1e1e1;
  padding: 7px;
  font-size: 16px;
  border-radius: 5px 0 0 5px;
}
@media (max-width: 780px) {
=======
<style type="text/css">
  .asset-name small{
    font-weight: normal;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 150px;
    font-size: 12px;
    vertical-align: middle;
  }
  .documentlist th,
  .documentlist td {
    padding: 5px;
  }
  .DocumentSearchBox {
    width: 75%;
    position: relative;
  }
  .displayNone {
    display: none !important;
  }
  .margin-right {
    margin-right: 10px;
  }
  .viewdetail {
    cursor: pointer;
  }
  .DocumentListDiv.show {
    display: block;
  }
  .DocumentListDiv.hide {
    display: none;
  }
  .DocumentSearchBtn {
    width: 100%;
    text-align: right;
    margin-top: 10px;
  }
  .DocumentSearchBox {
    width: 100%;
    position: relative;
  }
  .display-flex {
    display: inline;
  }
}
input[type="checkbox"] {
  max-width: 30px;
}
</style>
